import React, { useState, useEffect } from "react";

const CartTest = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCartDirectly = async () => {
    console.log("🧪 DIRECT TEST: Starting cart load");
    setLoading(true);
    setError(null);
    
    try {
      // Use the hardcoded user ID we know works
      const userId = "68ded148cbfe892dc87f3c45";
      const apiUrl = `http://localhost:5000/cart/${userId}`;
      console.log("🧪 DIRECT TEST: Loading cart for user:", userId);
      console.log("🧪 DIRECT TEST: API URL:", apiUrl);
      
      const response = await fetch(apiUrl);
      console.log("🧪 DIRECT TEST: Response status:", response.status);
      console.log("🧪 DIRECT TEST: Response ok:", response.ok);
      
      if (response.ok) {
        const data = await response.json();
        console.log("🧪 DIRECT TEST: Full response:", JSON.stringify(data, null, 2));
        
        if (data?.items && data.items.length > 0) {
          const items = data.items.map((item) => ({
            _id: item.product._id,
            name: item.product.name,
            quantity: item.quantity,
            realTimeTotalPrice: item.realTimeTotalPrice,
            coverImage: item.product.coverImage,
            ...item.product
          }));
          
          console.log("🧪 DIRECT TEST: Processed items:", items);
          setCartItems(items);
        } else {
          console.log("🧪 DIRECT TEST: No items in response");
          setCartItems([]);
        }
      } else {
        const errorText = await response.text();
        console.error("🧪 DIRECT TEST: API error:", response.status, response.statusText);
        console.error("🧪 DIRECT TEST: Error response:", errorText);
        setError(`API Error: ${response.status} ${response.statusText} - ${errorText}`);
      }
    } catch (error) {
      console.error("🧪 DIRECT TEST: Network error:", error);
      setError(`Network Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCartDirectly();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading cart directly...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 mb-4">Error: {error}</p>
          <button 
            onClick={loadCartDirectly}
            className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (cartItems.length === 0) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 mb-4">No items found in cart</p>
          <div className="space-x-4">
            <button 
              onClick={loadCartDirectly}
              className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
            >
              Reload Cart
            </button>
            <button 
              onClick={() => {
                console.log("🧪 MANUAL: Testing API call manually");
                fetch('http://localhost:5000/cart/68ded148cbfe892dc87f3c45')
                  .then(res => {
                    console.log("🧪 MANUAL: Response status:", res.status);
                    return res.json();
                  })
                  .then(data => {
                    console.log("🧪 MANUAL: Response data:", data);
                  })
                  .catch(err => {
                    console.error("🧪 MANUAL: Error:", err);
                  });
              }}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Test API Call
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#FAF7F2] min-h-screen px-4 sm:px-6 lg:px-10 py-10">
      <div className="p-6 bg-white shadow-md w-full">
        <h1 className="text-2xl font-bold mb-6">Direct Cart Test - {cartItems.length} Items</h1>
        
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead className="bg-[#784421] text-white">
              <tr>
                <th className="py-3 px-4">Product</th>
                <th className="py-3 px-4">Price</th>
                <th className="py-3 px-4">Quantity</th>
                <th className="py-3 px-4">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item, index) => (
                <tr key={index} className="border-b">
                  <td className="py-3 px-4 flex items-center space-x-4">
                    <img
                      src={item.coverImage || "https://via.placeholder.com/50"}
                      alt={item.name}
                      className="w-16 h-16 object-cover"
                    />
                    <span className="truncate font-semibold">{item.name}</span>
                  </td>
                  <td className="py-3 px-4">
                    ₹{item.realTimeTotalPrice / item.quantity}
                  </td>
                  <td className="py-3 px-4">
                    <span className="px-4 text-lg">{item.quantity}</span>
                  </td>
                  <td className="py-3 px-4">₹{item.realTimeTotalPrice}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        <div className="mt-6 p-4 bg-gray-50 rounded">
          <h3 className="font-bold mb-2">Debug Info:</h3>
          <p><strong>Items Found:</strong> {cartItems.length}</p>
          <p><strong>Raw Data:</strong> {JSON.stringify(cartItems, null, 2)}</p>
        </div>
      </div>
    </div>
  );
};

export default CartTest;
